import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { useState } from 'react';
import ActivationSuccessModal from 'ui-addon-upgrades/_core/common/components/activation/ActivationSuccessModal';
import { NEXT_STEPS_SURVEY_API_NAMES } from 'ui-addon-upgrades/_core/common/constants/trials';
import { upgradeDataPropsInterface } from 'ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import { sourceKeys } from 'ui-addon-upgrades/_core/common/data/upgradeData/properties/sources';
import TrialActivationNextStepsModal from './TrialActivationNextStepsModal';
// @ts-expect-error dependency missing types
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import Tx120SurveyLoadingModal from './Tx120SurveyLoadingModal';
import Tx120LockedFeatureSurveyModal from './tx-120/Tx120LockedFeatureSurveyModal';
import Tx120PricingPageSurveyModal from './tx-120/Tx120PricingPageSurveyModal';
import { jsx as _jsx } from "react/jsx-runtime";
const SUCCESS_MODAL_TYPES = {
  INITIAL_SUCCESS: 'INITIAL_SUCCESS',
  NEXT_STEPS_SURVEY: 'NEXT_STEPS_SURVEY',
  TX_120_LOCKED_FEATURE_SURVEY: 'TX_120_LOCKED_FEATURE_SURVEY',
  TX_0120_PRICING_PAGE_SURVEY: 'TX_0120_PRICING_PAGE_SURVEY',
  TX_0120_LOADING_SURVEY: 'TX_0120_LOADING_SURVEY'
};
const TrialActivationSuccessContainer = ({
  hideBackground,
  header,
  subText,
  ctaText,
  onSuccess,
  upgradeData,
  shouldHideSurvey,
  showIllustration,
  showTrialLoadingState,
  canViewNewSeats,
  isEligibleForTX0120,
  isTX0120Fetched,
  isTX0120Variant,
  isUpgradeModal
}) => {
  const {
    upgradeProduct,
    apiName,
    app
  } = upgradeData;
  const apiNameToUse = apiName || UpgradeProductToApiNameMap[upgradeProduct];
  const shouldShowTx0120Survey = isTX0120Fetched && isEligibleForTX0120 && isTX0120Variant;
  let initialModal = SUCCESS_MODAL_TYPES.INITIAL_SUCCESS;
  const isLockedFeature = isUpgradeModal || app === 'paywall-ui';
  if (shouldShowTx0120Survey && isLockedFeature) {
    initialModal = SUCCESS_MODAL_TYPES.TX_120_LOCKED_FEATURE_SURVEY;
  } else if (shouldShowTx0120Survey) {
    initialModal = SUCCESS_MODAL_TYPES.TX_0120_PRICING_PAGE_SURVEY;
  }
  const [successModalType, setSuccessModalType] = useState(initialModal);
  const maybeShowNextStepsSurvey = () => {
    const nextStepsIncludesProduct = NEXT_STEPS_SURVEY_API_NAMES.includes(apiNameToUse);
    const shouldShowNextStepsSurvey = nextStepsIncludesProduct && !shouldHideSurvey;
    if (shouldShowNextStepsSurvey) {
      setSuccessModalType(SUCCESS_MODAL_TYPES.NEXT_STEPS_SURVEY);
    } else if (onSuccess) {
      onSuccess();
    }
  };
  const renderHeader = shouldShowTx0120Survey ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "upgrades.activationModal.tx0120Title"
  }) : header;
  switch (successModalType) {
    case SUCCESS_MODAL_TYPES.NEXT_STEPS_SURVEY:
      return /*#__PURE__*/_jsx(TrialActivationNextStepsModal, {
        upgradeData: upgradeData,
        canViewNewSeats: canViewNewSeats
      });
    case SUCCESS_MODAL_TYPES.INITIAL_SUCCESS:
      return /*#__PURE__*/_jsx(ActivationSuccessModal, {
        type: sourceKeys.TRIAL,
        hideBackground: hideBackground,
        header: renderHeader,
        subText: subText,
        ctaText: ctaText,
        showIllustration: showIllustration,
        showTrialLoadingState: showTrialLoadingState,
        onSuccess: maybeShowNextStepsSurvey,
        upgradeData: upgradeData,
        canViewNewSeats: canViewNewSeats,
        shouldShowTX0120Survey: shouldShowTx0120Survey
      });
    case SUCCESS_MODAL_TYPES.TX_0120_PRICING_PAGE_SURVEY:
      return /*#__PURE__*/_jsx(Tx120PricingPageSurveyModal, {
        apiName: apiNameToUse,
        setInitialSuccessModal: () => setSuccessModalType(SUCCESS_MODAL_TYPES.INITIAL_SUCCESS),
        setLoadingModal: () => setSuccessModalType(SUCCESS_MODAL_TYPES.TX_0120_LOADING_SURVEY),
        upgradeData: upgradeData
      });
    case SUCCESS_MODAL_TYPES.TX_120_LOCKED_FEATURE_SURVEY:
      return /*#__PURE__*/_jsx(Tx120LockedFeatureSurveyModal, {
        apiName: apiNameToUse,
        onSuccess: onSuccess,
        upgradeData: upgradeData
      });
    case SUCCESS_MODAL_TYPES.TX_0120_LOADING_SURVEY:
      {
        const onLoadingFinish = () => {
          setSuccessModalType(SUCCESS_MODAL_TYPES.INITIAL_SUCCESS);
        };
        return /*#__PURE__*/_jsx(Tx120SurveyLoadingModal, {
          onLoadingFinish: onLoadingFinish,
          apiName: apiNameToUse
        });
      }
    default:
      return null;
  }
};
TrialActivationSuccessContainer.propTypes = Object.assign({
  hideBackground: PropTypes.bool.isRequired,
  header: PropTypes.node,
  subText: PropTypes.node,
  ctaText: PropTypes.node,
  showIllustration: PropTypes.bool,
  shouldHideSurvey: PropTypes.bool,
  onSuccess: PropTypes.func,
  showTrialLoadingState: PropTypes.bool
}, upgradeDataPropsInterface);
export default TrialActivationSuccessContainer;